export const parseNumberOfItemsInBasketFromGroupcallData = (groupcallData) => {
  if (typeof groupcallData?.results !== 'undefined' && Array.isArray(groupcallData.results)) {
    const cartItem = groupcallData.results.find(
      (resultsItem) => (
        resultsItem?.placeholder === '#cart' &&
        resultsItem?.response?.result === 'OK' &&
        typeof resultsItem?.response?.content === 'string'
      )
    );

    if (cartItem) {
      const numberOfItemsInBasketHTML = cartItem.response.content;
      const matchResult = numberOfItemsInBasketHTML.match(/>\s*(([1-9][0-9]*)|0)\s*</);

      if (Array.isArray(matchResult) && typeof matchResult[1] === 'string') {
        const numberOfItemsInBasketInteger = parseInt(matchResult[1], 10);

        if (!Number.isNaN(numberOfItemsInBasketInteger)) {
          return numberOfItemsInBasketInteger;
        }
      }
    }
  }

  return 0;
};
